<template>
  <el-container class="contnet">
    <el-header style="padding: 0"><MenuVue></MenuVue></el-header>
    <el-main style="width: 100vw; height: calc(100vh - 60px); padding: 0">
      <RouterView v-slot="{ Component }">
        <!-- <Transition> -->
        <KeepAlive>
          <component :is="Component" />
        </KeepAlive>
        <!-- </Transition> -->
      </RouterView>
    </el-main>
  </el-container>
</template>
<script>
import MenuVue from "@/components/Menu/index.vue";
export default {
  components: { MenuVue },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.contnet {
  width: 100vw;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue